import { NgModule, ErrorHandler, ModuleWithProviders } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import {
  UnwrapTagDirective,
  HrefPreventDefaultDirective,
  DefaultImageDirective,
  NumberDirective,
  TextFocusGuruDirective,
  DropDownFocusGuruDirective
} from './directives';
import { ValidateMaxDirective } from './directives/validator/validate.max.directive';
import { ValidateMinDirective } from './directives/validator/validate.min.directive';
import { ValidateMinLengthDirective } from './directives/validator/validate.minlength.directive';
import { CurrencyGuru } from './pipe/currency-guru.pipe';
import { ValidateMaxLengthDirective } from './directives/validator/validate.maxlength.directive';

@NgModule({
  declarations: [
    UnwrapTagDirective,
    DefaultImageDirective,
    HrefPreventDefaultDirective,
    NumberDirective,
    TextFocusGuruDirective,
    DropDownFocusGuruDirective,
    ValidateMaxDirective,
    ValidateMinDirective,
    ValidateMinLengthDirective,
    ValidateMaxLengthDirective,
    CurrencyGuru
  ],
  imports: [],
  exports: [
    UnwrapTagDirective,
    DefaultImageDirective,
    HrefPreventDefaultDirective,
    NumberDirective,
    TextFocusGuruDirective,
    DropDownFocusGuruDirective,
    ValidateMaxDirective,
    ValidateMinDirective,
    ValidateMinLengthDirective,
    ValidateMaxLengthDirective,
    CurrencyGuru
  ]
})
export class SystemicModule {
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/systemic.module.ts